import { render, staticRenderFns } from "./TaskDonorbox.vue?vue&type=template&id=73e068cd&scoped=true&"
import script from "./TaskDonorbox.vue?vue&type=script&lang=js&"
export * from "./TaskDonorbox.vue?vue&type=script&lang=js&"
import style0 from "./TaskDonorbox.vue?vue&type=style&index=0&id=73e068cd&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e068cd",
  null
  
)

export default component.exports